import { faCheckCircle, faInfoCircle, faWarning, faXmarkCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NotificationData, notifications } from '@mantine/notifications';
import { Box, Text, Button } from '@ui-lib';
import { palette } from '@ui-lib/color';

interface NotificationContentProps {
  content: string;
  buttonContent?: string;
  buttonIcon?: JSX.Element;
  buttonOnClick?: () => void;
}

type NotificationTone = 'positive' | 'critical' | 'info' | 'caution';

export interface NotificationProps {
  id?: string;
  tone?: NotificationTone;
  notificationContent: NotificationContentProps;
  onClose?: () => void;
}

const NotificationContent = (props: NotificationContentProps) => {
  return (
    <Box justifyContent="spaceBetween" alignItems="center" display="flex" gap="medium">
      <Text size="small" untrimmed>
        {props.content}
      </Text>
      {props.buttonContent && (
        <Button iconLeading={props.buttonIcon} onClick={props.buttonOnClick} size="small">
          {props.buttonContent}
        </Button>
      )}
    </Box>
  );
};

const notificationBackgroundColor = (tone?: NotificationTone) => {
  switch (tone) {
    case 'positive':
      return palette.green[10];
    case 'critical':
      return palette.red[40];
    case 'caution':
      return palette.yellow[40];
    case 'info':
    default:
      return palette.blue[10];
  }
};

const notificationIcon = (tone?: NotificationTone) => {
  switch (tone) {
    case 'positive':
      return <FontAwesomeIcon icon={faCheckCircle} style={{ color: palette.black }} />;
    case 'critical':
      return <FontAwesomeIcon icon={faXmarkCircle} style={{ color: palette.black }} />;
    case 'caution':
      return <FontAwesomeIcon icon={faWarning} style={{ color: palette.black }} />;
    case 'info':
    default:
      return <FontAwesomeIcon icon={faInfoCircle} style={{ color: palette.black }} />;
  }
};

export const showNotification = ({ onClose, ...props }: NotificationProps) => {
  const backgroundColor = notificationBackgroundColor(props.tone);
  notifications.show({
    id: props.id,
    icon: notificationIcon(props.tone),
    color: 'transparent',
    position: 'bottom-center',
    radius: 'large',
    message: <NotificationContent {...props.notificationContent} />,
    style: { backgroundColor, width: '500px', padding: 'small' },
    iconSize: 20,
    justifyContent: 'center',
    onClose,
  } as NotificationData);
};
